import React, { useState, useEffect, useContext } from "react";
import Sidebar from "../../components/Sidebar";
import Typography from "@material-ui/core/Typography";
import { AuthContext } from "../../context/AuthContext";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Grid from "@material-ui/core/Grid";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import { CloudDownload, Search } from "@material-ui/icons";
import moment from "moment";

const useStyle = makeStyles({
  table: {
    minWidth: 500,
  },
});
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
    position: "relative",
    top: 6,
  },
}));

const ExportTransactionData = () => {
  const classes = useStyles();
  const { auth, logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  let date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  let firstDay = new Date(y, m, 1);

  const [selectedDate, setSelectedDate] = React.useState(new Date(firstDay));
  const [endDate, setEndDate] = React.useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleDownload = async () => {
    setLoading(true);
    try {
      let url = `/api/export/transaction-data?from=${moment(
        selectedDate
      ).format("YYYY-MM-DD")}&to=${moment(endDate).format("YYYY-MM-DD")}`;
      let res = await axios({
        url: url,
        method: "get",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `daily-active-user-${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
      //setAnalytics(res.data.data);
    } catch (error) {
      if (error) {
        if (error.response.status == 401) {
          logout();
        }
      }
    }
    setLoading(false);
  };

  return (
    <div className="wrapper">
      <Sidebar />
      <div className="wrapper-inner">
        <div
          style={{
            marginBottom: 30,
            textAlign: "center",
          }}
        >
          <Typography variant="h4">Export Transactions Data</Typography>
        </div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container justifyContent="center">
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              autoOk={true}
              margin="normal"
              id="date-picker-inline"
              label="Start Date"
              value={selectedDate}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              autoOk={true}
              margin="normal"
              id="date-picker-inline"
              label="End Date"
              value={endDate}
              onChange={handleEndDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
            <div
              className={classes.root}
              style={{
                alignItems: "end",
                display: "flex",
                marginLeft: 20,
                paddingBottom: 8,
              }}
            >
              <Button
                size="small"
                variant="contained"
                color="primary"
                disabled={loading}
                className={classes.button}
                endIcon={<CloudDownload />}
                onClick={handleDownload}
              >
                {loading ? "Exporting...." : "Export Data"}
              </Button>
            </div>
          </Grid>
        </MuiPickersUtilsProvider>
      </div>
    </div>
  );
};

export default ExportTransactionData;
